// Copyright (c) 2021 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateUserEntitlements = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.entitlements
    });

export default (state = getDefaultState().entitlements, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_ENTITLEMENTS]: updateUserEntitlements
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/entitlements.js